import { QueryHookOptions, useQuery } from "@apollo/client";
import queryGQL from "@whoppah/apollo/query/merchant/meTradeDiscount.graphql";
import {
  MeTradeDiscountQuery,
  MeTradeDiscountQueryVariables,
} from "@whoppah/apollo/schema";

export const useMeTradeDiscountQuery = (
  options?: QueryHookOptions<
    MeTradeDiscountQuery,
    MeTradeDiscountQueryVariables
  >
) => {
  return useQuery(queryGQL, options);
};
